// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { i18n } from '@/utils/i18n'
import Meta from 'vue-meta'
import store from '@/store'
import formatting from '@/mixins/formatting'
import VueCookies from 'vue-cookies'
import Toastr from 'vue-toastr'
import VueScrollTo from 'vue-scrollto'
import { fetchServerTimestamp } from '@/api/timestamp'
import { setServerTimestampDiff } from '@/utils/auth'
import { initializeGtm } from '@/utils/tracking'
import { VueMaskDirective } from 'v-mask'

import Flag from '@/components/Flag'
import RbIcon from '@/components/RbIcon'

import TheNavbar from '@/components/TheNavbar'
import TheFooter from '@/components/TheFooter'

import { BootstrapVue } from 'bootstrap-vue'
import { RebtelTooltip } from '@rebtel-dev/rebtel-ui-core'

Vue.component('RebtelTooltip', RebtelTooltip)

Vue.use(BootstrapVue)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(Meta)
Vue.use(VueCookies)
Vue.use(Toastr)
Vue.use(VueScrollTo)

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})

Vue.component('flag', Flag)
Vue.component('rb', RbIcon)

Vue.component('the-navbar', TheNavbar)
Vue.component('the-footer', TheFooter)

Vue.directive('mask', VueMaskDirective)

formatting.create(Vue)

initializeGtm()

let startApp = function () {
  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
  })
}

fetchServerTimestamp().then((response) => {
  setServerTimestampDiff(response)
  startApp()
}).catch(() => {
  setServerTimestampDiff(null)
  startApp()
})



// WEBPACK FOOTER //
// ./src/main.js